import { useMutation } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions, useRefetchQuery } from "libs/reactQuery";

import { FinancialSettings } from "../financialReport.types";
import { requestUpdateFinancialSettings } from "./updateFinancialSettings.request";

const useUpdateFinancialSettings = (
  options?: MutationOptions<
    FinancialSettings,
    ApiServiceError<ApiError>,
    FinancialSettings
  >
) => {
  const refetchSettings = useRefetchQuery(["financial-settings"]);
  const refetchRevenueBreakdown = useRefetchQuery(["revenue-breakdown"]);

  return useMutation({
    mutationFn: requestUpdateFinancialSettings,
    onError: toastServerError,
    ...options,
    onSuccess: (data, variables, context) => {
      refetchSettings();
      refetchRevenueBreakdown();
      options?.onSuccess?.(data, variables, context);
    }
  });
};

export default useUpdateFinancialSettings;
